import React from 'react';
import GroupCard from './GroupCard';
import { observer } from 'mobx-react';
import Slider from 'react-slick';
import store from '../../../../stores/store';

const GroupCarousel = observer(
    class GroupCarousel extends React.Component {
        getSettings = lenght => {
            return {
                dots: lenght > 2,
                arrows: true,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 600,
                infinite: false,
                slidesToShow: 8,
                slidesToScroll: 8,
                responsive: [
                    {
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 7,
                            slidesToScroll: 7,
                            dots: lenght > 7,
                        },
                    },
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 6,
                            dots: lenght > 6,
                        },
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                            dots: lenght > 5,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            dots: lenght > 4,
                        },
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            dots: lenght > 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: lenght > 2,
                        },
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: lenght > 1,
                        },
                    },
                ],
            };
        };

        componentDidMount() {
            store.groups.groupsUpdateDelegate = this.update;
        }

        update = () => {
            this.forceUpdate();
        };

        onClick = (GroupId, groupsIndex, e) => {
            const currentSelectedId = store.groups.selectedId;
            store.groups.toggleSelected(GroupId, groupsIndex);
            store.groups.checkSelectedGovCatId(currentSelectedId);
            setTimeout(() => this.forceUpdate(), 50);
        };

        slickGoTo = index => {
            if (this.slider) {
                this.slider.slickGoTo(index);
            }
        };

        getLogo = coIndex => {
            if (typeof store.companies.logos[coIndex] !== 'undefined') {
                const logo =
                    store.companies.logos.length > 0 ? store.companies.logos[coIndex].url : '';
                return logo;
            }
            return '';
        };

        render() {
            if (!store.groups.allGroups || store.groups.allGroups.length === 0) {
                return <div className="item ml-2 text-muted">No groups</div>;
            } else {
                return (
                    <div>
                        <Slider
                            ref={s => (this.slider = s)}
                            {...this.getSettings(store.groups.allGroups.length)}
                        >
                            {store.groups.allGroups.map((detail, i) => (
                                <li key={i}>
                                    <GroupCard
                                        key={i}
                                        logo={this.getLogo(detail.groupsIndex)}
                                        index={i}
                                        details={detail}
                                        onClick={this.onClick}
                                        selected={store.groups.selectedId === detail.GroupId}
                                    />
                                </li>
                            ))}
                        </Slider>
                    </div>
                );
            }
        }
    },
);

export default GroupCarousel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Group/components/GroupCarousel.js